var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurgerMenu3ErboldBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.000000, 15.000000)",
    fill: "currentColor",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 70,
    height: 10.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 59.5,
    width: 70,
    height: 10.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 30,
    width: 70,
    height: 10.5,
    rx: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerMenu3ErboldBlack);
export default __webpack_public_path__ + "static/media/Burger Menu 3er bold Black.1f76fbdd152019bb7103006e0cfcf4fd.svg";
export { ForwardRef as ReactComponent };